import { Zap } from 'lucide-react';

export function Logo() {
  return (
    <div className="flex items-center gap-2">
      <Zap className="w-8 h-8 text-[#ffcc32]" />
      <span className="font-bold text-2xl tracking-tight">VINCER</span>
    </div>
  );
}